<template>
  <div class="" style="display: flex;height: 100%;">
    <!-- 左侧 -->
    <div style="flex-shrink: 0;background-color: white;">
      <div style="height: 58px;margin-right: 0;display: flex;align-items: center;justify-content: center;"
           :style="`width: ${logoWidth}px;`">
        <img src="../assets/logo.png" style="width: 60px;flex-shrink: 0"/>
      </div>
      <div class="line"></div>
      <div v-if="!isCollapse"
           style="display: flex;align-items: center;height: auto;padding: 15px 15px 15px 20px;cursor:default">
        <img src="../assets/avatar.png"
             style="width: 60px;height: 60px;border-radius: 30px;"/>
        <div style="margin-left: .75rem;">
          <div style="color: #000;font-family: 'opensans-semibold', sans-serif;font-size: 18px;">
            {{ userInfo.nickName }}
          </div>
          <div style="color: #2150B7;font-size: 16px;margin-top: .3rem;font-family: 'Montserrat-regular',
							sans-serif;">UID:{{ userInfo.userId }}
          </div>
        </div>
      </div>
      <div class="line"></div>
      <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @select="select"
               :collapse="isCollapse" style="border-right:none;width: 100%;">
        <div class="menuTitle" v-show="!isCollapse">我的</div>
        <el-menu-item index="1" v-if="userInfo.userType!=='03'">
          <i class="el-icon-wind-power" style="color: #2150B7;"></i>
          <span slot="title" style="color: black;">我的资料</span>
        </el-menu-item>
        <div class="line"></div>
        <el-menu-item index="2">
          <i class="el-icon-wind-power" style="color: #2150B7;"></i>
          <span slot="title" style="color: black;">我的成绩</span>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 右侧 -->
    <div style="width: 100%;">
      <div
          style="height: 58px;width: 100%;background-color: #2150b7;display: flex;justify-content: space-between;align-items: center;">
        <div style="padding-left: 0.625rem;display: flex;align-items: center;">
          <img @click="changeCollapse" src="../assets/icons/ic_menu.png"
               style="width: 20px;height: 20px;cursor:pointer;"/>
          <img @click="toggleFullscreen" src="../assets/icons/ic_reg.png"
               style="width: 20px;height: 20px;margin-left: 1.25rem;cursor:pointer;"/>
        </div>
        <el-popover placement="bottom" v-model="visible">
          <div style="text-align: right; margin: 0;color: #12131a;font-size: .9rem;">
            <div @click="updPopup"
                 style="display: flex;align-items: center;height: 50px;line-height: 50px;cursor:default">
              <img src="../assets/icons/ic_refresh.png" style="width: 16px;height: 16px;"/>
              <div style="margin-left: 10px;">修改密码</div>
            </div>
            <div class="line"></div>
            <div @click="logout"
                 style="display: flex;align-items: center;height: 50px;line-height: 50px;cursor:default">
              <img src="../assets/icons/ic_logout.png" style="width: 16px;height: 16px;"/>
              <div style="margin-left: 10px;">退出登录</div>
            </div>
          </div>
          <div slot="reference" style="padding-right: 2rem;color: white;cursor:pointer">
            我<i class="el-icon-caret-bottom" style="margin-left: 6px;"></i>
          </div>
        </el-popover>
      </div>
      <div style="padding: 1.88rem 1.81rem;">
        <div style="background-color: white;width: 100%;">
          <div style="color: white;">1</div>
          <div style="margin: 0 20px;padding: 20px">
            <div v-if="defaultActive=='1'&&userInfo.userType!=='03'">
              <div style="font-size: 1.88rem;font-weight: 500;">我的资料</div>
              <div class="line" style="margin: 20px 0 15px 0px;background-color: rgba(0, 0, 0, 0.1);;">
              </div>
              <!-- <el-alert title="我的资料未完善" type="error" description="您的资料尚未完善，请完善全部资料" show-icon>
              </el-alert> -->
              <div style="margin-top: 50px;">
                <el-form :model="personForm" :rules="rules" ref="personForm" label-width="110px"
                         label-position="left" class="" style="width: 500px;">
                  <el-form-item label="所在地区" prop="region">
                    <!-- <el-cascader v-model="personForm.region" :options="options"
                      :props="{ checkStrictly: true }" style="width: 100%;"
                      clearable></el-cascader> -->
                    <el-input v-model="personForm.region" readonly></el-input>
                  </el-form-item>
                  <el-form-item label="个人姓名" prop="name">
                    <el-input v-model="personForm.name" readonly></el-input>
                  </el-form-item>
                  <el-form-item label="性别" prop="sex">
                    <el-radio-group v-model="personForm.sex" disabled>
                      <el-radio label="男"></el-radio>
                      <el-radio label="女"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="证件类型" prop="idCardType">
                    <el-select v-model="personForm.idCardType" placeholder="请选择证件类型"
                               disabled>
                      <el-option label="身份证" value="1"></el-option>
                      <el-option label="港澳通行证" value="2"></el-option>
                      <el-option label="台胞证" value="3"></el-option>
                      <el-option label="护照" value="4"></el-option>
                      <el-option label="其他证件" value="5"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="证件号码" prop="idCardNum">
                    <el-input v-model="personForm.idCardNum" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="在读学校" prop="schoolName">
                    <el-input v-model="personForm.schoolName"></el-input>
                  </el-form-item>

                  <el-form-item label="年级" prop="grade">
                    <el-select v-model="personForm.grade" placeholder="请选择年级" disabled>
                      <el-option label="学龄前" value="0"></el-option>
                      <el-option label="一年级" value="1"></el-option>
                      <el-option label="二年级" value="2"></el-option>
                      <el-option label="三年级" value="3"></el-option>
                      <el-option label="四年级" value="4"></el-option>
                      <el-option label="五年级" value="5"></el-option>
                      <el-option label="六年级" value="6"></el-option>
                      <el-option label="七年级" value="7"></el-option>
                      <el-option label="八年级" value="8"></el-option>
                      <el-option label="九年级" value="9"></el-option>
                      <el-option label="高一" value="10"></el-option>
                      <el-option label="高二" value="11"></el-option>
                      <el-option label="高三" value="12"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm('personForm')"
                               style="width: 100%;font-size: 16px;height: 48px;">确认修改
                    </el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>

            <div v-if="defaultActive=='2'">
              <div style="background-color: #eaeef7;text-align: center;">
                <div style="height: 60px;line-height: 60px;font-size: 20px;font-weight: 700;">
                  中科亚欧科学技术中心综合素质能力评价及成果展示查询平台
                </div>
                <div style="color: red;padding: 10px 0;font-size: 22px;">荣誉报告</div>
              </div>
              <div class="scrollable-container" v-if="honourList.length>0"
                   style="height: 500px;overflow-y: scroll;">
                <div v-for="(item,index) in honourList" :key="index">
                  <table>
                    <tr>
                      <td style="width: 10%;">姓名</td>
                      <td style="width: 40%;">{{ item.userInfo.nickName }}</td>
                      <td style="width: 40%;text-align: center;" rowspan="6">
                        <img src="../assets/avatar.png" v-if="userInfo.userType==='03'"
                             style="width: 30%;height: 50%;"/>
                        <img v-else :src="item.userInfo.sex=='1'?manUrl:womanUrl"
                             style="width: 30%;height: 50%;"/>
                      </td>
                    </tr>
                    <tr>
                      <td>性别</td>
                      <td>
                        {{ item.userInfo.sex == '1' ? '男' : item.userInfo.sex == '2' ? '女' : '未知' }}
                      </td>
                    </tr>
                    <tr>
                      <td>地区</td>
                      <td>
                        {{ item.personalInfo.province }}/{{ item.personalInfo.city }}/{{ item.personalInfo.area }}
                      </td>
                    </tr>
                    <tr>
                      <td>学校</td>
                      <td>{{ item.personalInfo.schoolName }}</td>
                    </tr>
                    <tr>
                      <td>证件类型</td>
                      <td>{{ item.personalInfo.idCardType }}</td>
                    </tr>
                    <tr>
                      <td>证件号码</td>
                      <td>{{ item.personalInfo.idCardNum }}</td>
                    </tr>
                    <tr>
                      <td>赛事</td>
                      <td colspan="2">{{ item.matchName }}</td>
                    </tr>
                    <tr>
                      <td>编号</td>
                      <td colspan="2">{{ item.matchNo }}</td>
                    </tr>
                    <tr>
                      <td>阶段</td>
                      <td colspan="2">{{ item.matchStage }}</td>
                    </tr>
                    <tr>
                      <td>荣誉</td>
                      <td colspan="2">{{ item.matchHonour }}</td>
                    </tr>
                    <tr>
                      <td>晋级状态</td>
                      <td colspan="2" v-if="userInfo.userType==='03'">
                        {{ item.promote }}
                      </td>
                      <td colspan="2" v-else>
                        {{ item.matchHonour == "省一" ? "晋级" : item.matchHonour == "省二" ? "晋级" : "未晋级" }}
                      </td>
                    </tr>
                  </table>
                  <div style="height: 10px;" v-if="index!=honourList.length-1"></div>
                </div>
              </div>
              <div v-else style="text-align: center;">
                <img src="https://www.nychkc.com/home/img/other.868f2dd.png"
                     style="width: 274px;height: 174px;margin: 50px auto 0;"/>
                <div style="font-size: 14px;color: #969696;margin-top: 20px;margin-bottom: 290px;">
                  暂无奖项与成绩记录哟~
                </div>
              </div>
              <div v-if="honourList.length>0"
                   style="background-color: #eaeef7;text-align: center;padding: 15px;">
                <div style="color: red;font-size: 12px;">
                  注：本报告仅供参赛选手本人查询，非正式证书，不得用于其他用途。
                </div>
                <el-button v-if="false" type="danger" style="margin-top: 20px;">申请证书</el-button>
              </div>
            </div>
            <div v-if="defaultActive=='7'">
              <div style="font-size: 1.88rem;font-weight: 500;">修改密码</div>
              <div class="line" style="margin: 20px 0 15px 0px;background-color: rgba(0, 0, 0, 0.1);;">
              </div>
              <el-form ref="pwdForm" label-position="left" label-width="110px" :model="pwdForm"
                       style="width: 500px;">
                <el-form-item label="旧密码" prop="oldPwd">
                  <el-input v-model="pwdForm.oldPwd" show-password
                            placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPwd">
                  <el-input v-model="pwdForm.newPwd" show-password
                            placeholder="请设置密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="surePwd">
                  <el-input v-model="pwdForm.surePwd" show-password
                            placeholder="请确认密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitPwd('pwdForm')"
                             style="width: 100%;height: 48px;font-size: 16px;">确认修改
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {editPersonal, getHonourList, getPersonal, updateUserPwd} from '@/api/inter.js'

export default {
  name: 'HomePage',
  data() {
    return {
      userInfo: {},
      womanUrl: "https://qy.cmxtw.com/store/comment/43fff202405020138441171.png",
      manUrl: "https://qy.cmxtw.com/store/comment/4731a202406012308484067.png",
      defaultActive: '1',
      honourList: [],
      visible: false,
      isCollapse: false,
      logoWidth: 265,
      personForm: {
        region: '',
        name: '',
        sex: '',
        idCardType: '',
        idCardNum: '',
        schoolName: '',
        grade: ''
      },
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        surePwd: ''
      },
      rules: {
        region: [{
          required: true,
          message: '请选择地区',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        },
          {
            min: 2,
            max: 5,
            message: '长度在 2 到 5 个字符',
            trigger: 'blur'
          }
        ],
        sex: [{
          required: true,
          message: '请选择性别',
          trigger: 'blur'
        }],
        idCardType: [{
          required: true,
          message: '请选择证件类型',
          trigger: 'change'
        }],
        idCardNum: [{
          required: true,
          message: '请输入证件号码',
          trigger: 'change'
        }],
        schoolName: [{
          required: true,
          message: '请输入学校名称',
          trigger: 'blur'
        }],
        grade: [{
          required: true,
          message: '请选择年级',
          trigger: 'blur'
        }]
      }
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (this.userInfo.userType === '03') {
      this.defaultActive = '2'
      this.initHonour()
    } else {
      getPersonal().then(res => {
        console.log(res);
        if (res.code == 200) {
          this.userInfo.person = res.data
          localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
          this.personForm.region = res.data.province + "/" + res.data.city + "/" + res.data.area
          this.personForm.name = this.userInfo.nickName
          this.personForm.sex = this.userInfo.sex == "1" ? '男' : this.userInfo.sex == "2" ? '女' : '其他'
          this.personForm.idCardType = res.data.idCardType
          this.personForm.idCardNum = res.data.idCardNum
          this.personForm.schoolName = res.data.schoolName
          this.personForm.grade = this.userInfo.grade
        }
      })
    }
  },
  methods: {
    initHonour() {
      if (this.honourList.length < 1) {
        getHonourList().then(res => {
          console.log(res);
          this.honourList = res.rows
        })
      }
    },
    updPopup() {
      this.defaultActive = '7'
      this.visible = false
    },
    logout() {
      localStorage.clear()
      this.$router.push('/login')
      console.log(123131);
    },
    submitForm(formName) {
      console.log("personForm", this.personForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editPersonal(this.personForm).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              })
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    submitPwd() {
      if (!this.pwdForm.oldPwd) {
        this.$message({
          message: '请输入旧密码',
          type: 'error'
        });
        return
      }
      if (!this.pwdForm.newPwd) {
        this.$message({
          message: '请输入新密码',
          type: 'error'
        });
        return
      }
      if (this.pwdForm.newPwd != this.pwdForm.surePwd) {
        this.$message({
          message: '两次密码不一致',
          type: 'error'
        });
        return
      }
      updateUserPwd(this.pwdForm.oldPwd, this.pwdForm.newPwd).then(response => {
        if (response.code == 200) {
          // this.$modal.msgSuccess("修改成功");
          this.defaultActive = '1'
          this.$message({
            message: response.msg,
            type: 'success'
          });
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          });
        }
      });
    },
    //切换左侧菜单
    changeCollapse() {
      this.isCollapse = !this.isCollapse
      this.logoWidth = this.isCollapse ? 70 : 265
    },
    //全屏缩放
    toggleFullscreen() {
      if (!document.fullscreenElement &&
          !document.mozFullScreenElement && !document.webkitFullscreenElement && !document
              .msFullscreenElement) { // 当前浏览器处于非全屏状态
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen().catch(err => {
            console.error("Error attempting to enable full-screen mode:", err);
          });
        } else if (document.documentElement.msRequestFullscreen) {
          // IE/Edge
          document.documentElement.msRequestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          // Firefox
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          // Chrome, Safari 和 Opera
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }

        document.addEventListener('fullscreenchange', this.fullscreenChange);
        document.addEventListener('mozfullscreenchange', this.fullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.fullscreenChange);
        document.addEventListener('MSFullscreenChange', this.fullscreenChange);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          // IE/Edge
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          // Chrome, Safari 和 Opera
          document.webkitExitFullscreen();
        }

        document.removeEventListener('fullscreenchange', this.fullscreenChange);
        document.removeEventListener('mozfullscreenchange', this.fullscreenChange);
        document.removeEventListener('webkitfullscreenchange', this.fullscreenChange);
        document.removeEventListener('MSFullscreenChange', this.fullscreenChange);
      }
    },
    fullscreenChange() {
      // 你可以在这里添加更多的逻辑来处理全屏状态的变化
    },
    select(key) {
      this.defaultActive = key + ''
      if (key == 2) {
        this.initHonour()
      }
    }
  }
}
</script>

<style lang="scss">
.line {
  height: 1px;
  background-color: #f5f5f5;

}

.menuTitle {
  color: #777;
  font-size: .9rem;
  padding: 20px 15px 11px 32px;
  height: auto;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  border: 1px solid #dedede;
  padding: 8px;
  text-align: left;
}

.scrollable-container::-webkit-scrollbar {
  display: none;
}

.el-input {
  height: 48px;

  input {
    height: 48px;
  }
}
</style>
